import { LIMITED } from 'conversations-thread-data/sms/public/constants';
export const smsBillingLimit = ({
  billingLimitStatus
}) => {
  return !billingLimitStatus || billingLimitStatus === LIMITED ? {
    disabled: true,
    sendDisabledReason: 'SMS_BILLING_LIMIT_REACHED'
  } : null;
};